/* eslint-disable default-param-last */
import concat from 'lodash/concat'

const HISTORY_LENGTH = 50

type HistoryAction = {
  type: string
  payload?: unknown
}

type HistoryState = {
  list: HistoryAction[]
}

const initState: HistoryState = {
  list: []
}

export default (
  state: HistoryState = initState,
  action: HistoryAction
): HistoryState => {
  const newList = concat(
    state.list,
    action
  )
  if (newList.length > HISTORY_LENGTH) {
    newList.shift()
  }
  return {
    ...state,
    list: newList
  }
}
